import { Button } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const BackButton = styled(Button)`
    position: absolute;
    left: 0;
`;
